/** @format */

import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import BLSpinner from "../assets/animations/BLSpinner/BLSpinner";
import { getUserToken, UserToken, setUserToken } from "./authSlice";
import { Buffer } from "buffer";
const Callback = () => {
  // callback from the filter site.
  // which should include the tkid to login the user
  // will redirect to last loaded resource once the user is logged in.

  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => getUserToken(state));

  useEffect(() => {
    const tkid = searchParams.get("tkid");
    if (!!tkid) {
      const tokenKeys = ["expires", "refreshToken", "token", "service"];
      const token: UserToken = JSON.parse(
        Buffer.from(tkid, "base64").toString("utf-8"),
      );

      if (
        Object.keys(token).every((key) => tokenKeys.includes(key)) &&
        token.expires > Date.now()
      ) {
        dispatch(setUserToken(token));
        // Update user token with new details only if all tokenKeys are present.
      }
      searchParams.delete("tkid");
      setSearchParams(searchParams, { replace: true });
    }
  }, [dispatch, searchParams, setSearchParams]);

  useEffect(() => {}, []);

  return token ? (
    <Navigate
      to={
        sessionStorage.getItem("redirectResource") === null
          ? "/"
          : `/${sessionStorage.getItem("redirectResource")}`
      }
    />
  ) : (
    <BLSpinner />
  );
};
export default Callback;
